import { SVGProps } from "react";

const VSCBlank = (props: SVGProps<SVGSVGElement>) => <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props} />;

export { VSCBlank };